import React from 'react'
import { Text, View, StyleSheet, Image, Pressable, Linking } from 'react-native'
import AppTheme from '../../AppTheme';
import { getImagePath } from '../../utils/services/CommonUtils';
import { AAYUPlayStoreURL } from '../constants/AppConstants';

export const GooglePlayBadge = (props) => {
    const viewStyle = props?.viewStyle ?? null
    const resize = props?.resize ?? 1
    return <Pressable onPress={() => {
        Linking.openURL(AAYUPlayStoreURL).catch((err) =>
            console.error('An error occured', err));
    }} style={[viewStyle]} onLongPress={() => { console.log('### long press') }}>
        <Image style={{ height: 56 * resize, width: 153 * resize }}
            source={{ uri: getImagePath('/images/icons/google_play.svg') }} />
    </Pressable>

}

export class AayuPlayStoreBadge extends React.Component {
    render() {
        return <Pressable onPress={() => {
            Linking.openURL(AAYUPlayStoreURL).catch((err) =>
                console.error('An error occured', err));
        }} onLongPress={() => { console.log('### long press') }}><View>
                <Image source={{ uri: getImagePath('/images/aayu_banner.webp'), height: AppTheme.appWidth * 0.35 }}></Image>
            </View>
        </Pressable>
    }
}

export class AayuFollowUpBadge extends React.Component {
    render() {
        return <Pressable onPress={() => {
            Linking.openURL(AAYUPlayStoreURL).catch((err) =>
                console.error('An error occured', err));
        }} onLongPress={() => { console.log('### long press') }}>
            <Image source={{
                uri: getImagePath('/images/aayu_followup_banner.png'),
                width: AppTheme.appWidth, height: AppTheme.appWidth * 0.35
            }}></Image>
        </Pressable>
    }
}

export const CommonAayuText = (props) => {
    return <Text style={styles.healthText}>YOUR HEALTH,<br></br>OUR MISSION</Text>
}

export const CommonWhiteMedcordsLogo = (props) => {
    return <Image style={[{ marginRight: props.marginRight ?? 4 }]}
        source={{
            uri: getImagePath('/images/Aayu_logo_white.png'),
            width: props.logoWidth ?? 10, height: props.height ?? 10
        }} />
}

export const CommonWhiteAayuLogo = (props) => {
    return <View style={{ flex: 1, flexDirection: 'row' }}>
        <Image style={[{ marginRight: props.marginRight ?? 4 }]}
            source={{
                uri: getImagePath('/images/Aayu_logo_white.png'),
                width: props.logoWidth ?? 10, height: props.height ?? 10
            }} />
        <Image source={{
            uri: getImagePath('/images/Aayu_text_white.png'),
            width: props.textWidth ?? 24, height: props.height ?? 10
        }} />
    </View>
}

export const CommonBlackAayuLogo = (props) => {
    return <View style={{ flex: 1, flexDirection: 'row' }}>
        <Image style={[{ marginRight: props.marginRight ?? 4 }]}
            source={{
                uri: getImagePath('/images/Aayu_logo_black.png'),
                width: props.logoWidth ?? 10, height: props.height ?? 10
            }} />
        <Image source={{
            uri: getImagePath('/images/Aayu_text_black.png'),
            width: props.textWidth ?? 24, height: props.height ?? 10
        }} />
    </View>
}

const styles = StyleSheet.create({
    healthText: {
        color: '#e5e5e5',
        fontSize: 24,
        lineHeight: 32,
        fontWeight: '600',
        marginHorizontal: 16,
        fontFamily: 'Roboto_400Regular'
    }
})